module.exports = {"mil":["Informationskunnighet","Bibliotekskunnighet","Yttrandefrihets- & informationsfrihetskunnighet","Digital kunnighet","Datorkunnighet","Internetkunnighet","Spelkunnighet","Filmkunnighet","TV-kunnighet","Nyhetskunnighet","Reklamkunnighet","Mediekunnighet"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/mil.json
// module id = S9+9
// module chunks = 0